import { render, staticRenderFns } from "./RulesView.vue?vue&type=template&id=56c9e222&scoped=true&"
import script from "./RulesView.vue?vue&type=script&lang=js&"
export * from "./RulesView.vue?vue&type=script&lang=js&"
import style1 from "./RulesView.vue?vue&type=style&index=1&id=56c9e222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9e222",
  null
  
)

export default component.exports